module.exports = {
  bpmnImporter: [ 'type', require(7) ]
};